import React from "react";

import { Icon } from "../../components/core/Icon";
import style from "./CashbackProgramIndicators.module.scss";
import { If } from "shared/components/control-statements";

export class CashbackProgramIndicators extends React.Component {
  getRawEarn() {
    const { reports = {} } = this.props;
    return (
      (reports.sales_total || 0) -
      (reports.distributed || 0) +
      (reports.expired_cashback || 0)
    );
  }

  formatCurrency(value) {
    const formated = parseFloat(value);

    return formated.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }

  render() {
    const { reports, cashbackProgram } = this.props;

    const programByPoint = cashbackProgram?.type === "POINT";

    return (
      <div className={style["grid-indicators"]}>
        <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>
              {programByPoint
                ? reports.distributed || 0
                : this.formatCurrency(reports.distributed || 0)}
            </p>
            <Icon name="fa-hand-holding-dollar" />
          </div>
          <span className={style.description}>
            Total de{" "}
            {programByPoint ? "pontos concebidos" : "cashback concebido"}
          </span>
          <span className={"line"} />
        </div>
        <If cond={!programByPoint}>
          <div className={style.card}>
            <div className="d-flex align-center">
              <p className={style.value}>{reports.sales_count || 0}</p>
            </div>
            <span className={style.description}>
              Total de vendas com cashback
            </span>
            <span className={"line"} />
          </div>
        </If>

        <If cond={!programByPoint}>
          <div className={style.card}>
            <div className="d-flex align-center">
              <p className={style.value}>
                {this.formatCurrency(reports.sales_total || 0)}
              </p>
            </div>
            <span className={style.description}>
              Total em vendas com cashback
            </span>
            <span className={"line"} />
          </div>
        </If>
        <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>
              {programByPoint
                ? reports.expired_points || 0
                : this.formatCurrency(reports.expired_points || 0)}
            </p>
          </div>
          <span className={style.description}>
            Total de {programByPoint ? "pontos expirados" : "cashback expirado"}
          </span>
          <span className={"line"} />
        </div>
        {/* <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>
              {this.formatCurrency(this.getRawEarn())}
            </p>
          </div>
          <span className={style.description}>Margem bruta</span>
          <span className={"line"} />
        </div> */}
        <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>{reports.new_customers || 0}</p>
          </div>
          <span className={style.description}>Novos cadastros gerados</span>
          <span className={"line"} />
        </div>
        <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>{reports.distribution_sent || 0}</p>
          </div>
          <span className={style.description}>Disparos do programa</span>
          <span className={"line"} />
        </div>
        {/* <div className={style.card}>
          <div className="d-flex align-center">
            <p className={style.value}>{reports.expiration_sent || 0}</p>
          </div>
          <span className={style.description}>Disparos de expiração</span>
          <span className={"line"} />
        </div> */}
      </div>
    );
  }
}
